import { ArrowLeft } from "lucide-react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CandidateProfile } from "../components/CandidateProfile";
import { ScoutSendPanel } from "../components/ScoutSendPanel";
import { mockCandidates } from "../data/mock-candidates";

export function CandidateDetailPage() {
  const { id } = useParams<{ id: string }>();
  const candidate = mockCandidates.find((c) => c.id === id);
  const [showScoutPanel, setShowScoutPanel] = useState(false);

  if (!candidate) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <p className="text-gray-500 text-lg">候補者が見つかりませんでした</p>
        <Link
          className="mt-4 text-purple-600 text-sm hover:text-purple-700"
          to="/direct-recruiting-sample/results"
        >
          一覧に戻る
        </Link>
      </div>
    );
  }

  return (
    <div className="flex gap-0">
      {/* 左: 候補者詳細 */}
      <div className={`flex-1 transition-all ${showScoutPanel ? "pr-0" : ""}`}>
        <div className="mb-4">
          <Link
            className="flex items-center gap-1 text-purple-600 text-sm hover:text-purple-700"
            to="/direct-recruiting-sample/results"
          >
            <ArrowLeft className="h-4 w-4" />
            一覧に戻る
          </Link>
        </div>
        <CandidateProfile candidate={candidate} onScoutClick={() => setShowScoutPanel(true)} />
      </div>

      {/* 右: スカウト送信パネル */}
      {showScoutPanel ? (
        <div className="ml-4 w-[630px] shrink-0">
          <div className="sticky top-16 h-[calc(100vh-5rem)] overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg">
            <ScoutSendPanel candidate={candidate} onClose={() => setShowScoutPanel(false)} />
          </div>
        </div>
      ) : null}
    </div>
  );
}
